import { getRecords, bySlug } from './baserow'

export default {
  getProjects () {
    return getRecords('Projects')
  },
  getProject (slug) {
    return getRecords('Projects', bySlug(slug))
  }
}
